export enum MODIFICATION_ACTION {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}
